import React from 'react'

const HomeExperience = () => {
  return (
   <>
   <>
  {/* Tpm Education Experience Area Start */}
  <section className="education-experience tmp-section-gapTop">
    <div className="container">
      <div className="section-head mb--50">
        <div className="section-sub-title center-title tmp-scroll-trigger tmp-fade-in animation-order-1">
          <span className="subtitle">Education & Experience</span>
        </div>
        <h2 className="title split-collab tmp-scroll-trigger tmp-fade-in animation-order-2 !text-6xl">
          Empowering Creativity Through Expertise & Strategic Insight
        </h2>
        <p className="description section-sm tmp-scroll-trigger tmp-fade-in animation-order-3">
          With a strong educational background and over a decade of real-world experience, I specialize in helping businesses enhance their performance through innovative strategy, design, and marketing solutions.
        </p>
      </div>
      <h2 className="custom-title mb-32 tmp-scroll-trigger tmp-fade-in animation-order-1">
        Education{" "}
        <span>
          <img
            src="assets/images/custom-line/custom-line.png"
            alt="custom-line"
          />
        </span>
      </h2>
      <div className="row g-5">
        <div className="col-lg-6 col-sm-6">
          <div className="education-experience-card tmponhover tmp-scroll-trigger tmp-fade-in animation-order-1">
            <h4 className="edu-sub-title">Trainer Marketing</h4>
            <h2 className="edu-title">2010 – 2014</h2>
            <p className="edu-para">
              Provided hands-on training in digital marketing, brand strategy, and customer engagement. Laid the foundation for impactful business communication and online growth.
            </p>
          </div>
        </div>
        <div className="col-lg-6 col-sm-6">
          <div className="education-experience-card tmponhover tmp-scroll-trigger tmp-fade-in animation-order-2">
            <h4 className="edu-sub-title">Assistant Director – Business Strategy</h4>
            <h2 className="edu-title">2015 – 2019</h2>
            <p className="edu-para">
              Led cross-functional teams, managed key client relationships, and implemented scalable strategies that drove measurable results across diverse industries.
            </p>
          </div>
        </div>
        <div className="col-lg-6 col-sm-6">
          <div className="education-experience-card tmponhover tmp-scroll-trigger tmp-fade-in animation-order-3">
            <h4 className="edu-sub-title">Design Assistant – Creative Solutions</h4>
            <h2 className="edu-title">2014 – 2016</h2>
            <p className="edu-para">
              Contributed to high-impact design projects, including UI/UX for web and mobile platforms, helping brands stand out with user-focused visual storytelling.
            </p>
          </div>
        </div>
        <div className="col-lg-6 col-sm-6">
          <div className="education-experience-card tmponhover tmp-scroll-trigger tmp-fade-in animation-order-4">
            <h4 className="edu-sub-title">Design Assistant</h4>
            <h2 className="edu-title">2008-2012</h2>
            <p className="edu-para">
              Each project here showcases my commitment to excellence and
              adaptability, tailored to meet each client’s unique needs a
              personal.
            </p>
          </div>
        </div>
      </div>
      <div className="experiences-wrapper">
        <div className="row">
          <div className="col-lg-6">
            <div className="experiences-wrap-left-content">
              <h2 className="custom-title mb-32 tmp-scroll-trigger tmp-fade-in animation-order-1">
                Professional Experience{" "}
                <span>
                  <img
                    src="assets/images/custom-line/custom-line.png"
                    alt="custom-line"
                  />
                </span>
              </h2>
              <div className="experience-content tmp-scroll-trigger tmp-fade-in animation-order-1">
                {/* <p className="ex-subtitle">experience</p> */}
                <h2 className="ex-name">Driving Innovation Through Design & Development Excellence</h2>
                {/* <h3 className="ex-title">UI/UX Designer</h3> */}
                <p className="ex-para">
                  With hands-on experience in UI/UX design and app development, I’ve contributed to digital projects that merge functionality with creativity—delivering results across platforms.
                </p>
              </div>
              <div className="experience-content tmp-scroll-trigger tmp-fade-in animation-order-2">
                {/* <p className="ex-subtitle">experience</p> */}
                <h2 className="ex-name">UI/UX Designer – Soft Tech (12 Years)</h2>
                {/* <h3 className="ex-title">App Developer</h3> */}
                <p className="ex-para">
                  Crafted intuitive and visually engaging user interfaces for web and mobile applications. Focused on enhancing user journeys, wireframing, prototyping, and collaborating with development teams to deliver seamless digital experiences.
                </p>
              </div>
              <div className="experience-content tmp-scroll-trigger tmp-fade-in animation-order-2">
                {/* <p className="ex-subtitle">experience</p> */}
                <h2 className="ex-name">App Developer – ModernTech (9 Years)</h2>
                {/* <h3 className="ex-title">App Developer</h3> */}
                <p className="ex-para">
                  Led full-cycle development of responsive mobile applications across iOS and Android platforms. Integrated user-centered design with scalable back-end functionality to create high-performance, cross-platform apps.
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="experiences-wrap-right-content">
              <img
                className="tmp-scroll-trigger tmp-zoom-in animation-order-1"
                src="assets/images/experiences/expert-img.jpg"
                alt="expert-img"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  {/* Tpm Education Experience Area End */}
</>

   </>
  )
}

export default HomeExperience